import RelatorioSectionTitle from "ui/components/Relatorio/RelatorioSectionTitle";

export const TableColumns = () => (
  <RelatorioSectionTitle
    containerProps={{ mt: 4, mb: 6 }}
    items={[
      {
        text: "Descrição",
        colSpan: 12,
        bold: true,
      },
      {
        text: "Competência",
        colSpan: 2,
        bold: true,
        textAlign: "center",
      },
      {
        text: "Liquidação",
        colSpan: 3,
        bold: true,
        textAlign: "center",
      },
      {
        text: "Forma de Pagamento",
        colSpan: 3,
        bold: true,
        textAlign: "center",
      },
      {
        text: "Nota Fiscal",
        colSpan: 2,
        bold: true,
        textAlign: "center",
      },
      {
        text: "Valor",
        colSpan: 2,
        textAlign: "right",
        bold: true,
      },
    ]}
  />
);
